module.exports = __webpack_public_path__ + "static/media/github.3c5c31ba.svg";